import React, { useState } from "react";
import { Play } from "lucide-react";
import { company } from "../mock";

const VIDEO_ID = "5xdCzXbHDPg"; // representative auto engine quality-control video

const QualityVideo = () => {
  const [play, setPlay] = useState(false);
  return (
    <section className="bg-[#0f2846] py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-white text-3xl md:text-4xl font-bold">Controllo qualità su ogni motore</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
          <p className="text-white/60 mt-5">Ogni motore prima di lasciare la nostra officina viene testato e verificato dai nostri tecnici. Controlliamo compressione, perdite, rumorosità e funzionamento di ogni componente per garantirti un prodotto sicuro e affidabile.</p>
        </div>
        <div className="mt-10 rounded-2xl overflow-hidden shadow-2xl aspect-video bg-black relative group">
          {play ? (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
              title="Controllo qualità motore"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button onClick={() => setPlay(true)} className="absolute inset-0 w-full h-full flex items-center justify-center" aria-label="Riproduci video">
              <img src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`} alt="video thumbnail" className="absolute inset-0 w-full h-full object-cover opacity-60" />
              <span className="relative w-20 h-20 rounded-full bg-[#e8464a] flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                <Play size={34} className="text-white ml-1" fill="currentColor" />
              </span>
            </button>
          )}
        </div>
        <p className="text-center text-white/50 text-sm mt-4">Controllo qualità motore in officina — {company.name}</p>
      </div>
    </section>
  );
};

export default QualityVideo;
